import type { UploadOptions, UploadResponse } from './DocImportService.ts';
import { getOriginalDraftId, uploadFile } from './DocImportService.ts';

export async function uploadFileWithDiscard({
	document,
	pageTitle,
	space,
	parentPageId,
	importSource,
	isDraftDiscard,
	contentId,
	isBulkUpload,
	signal,
	subType,
}: UploadOptions & { isDraftDiscard: boolean; contentId: string }): Promise<UploadResponse> {
	const uploadOptions: UploadOptions = {
		document,
		pageTitle,
		importSource,
		space,
		parentPageId,
		isBulkUpload,
		signal,
		subType,
	};

	if (isDraftDiscard) {
		const { metadata } = await getOriginalDraftId(contentId);
		uploadOptions.originalDraftId = metadata.properties.hasOwnProperty('originalDraftId')
			? metadata.properties.originalDraftId.value
			: contentId;
	}

	return uploadFile(uploadOptions);
}
